module.exports = __webpack_public_path__ + "static/media/washington-dc-77.90118403.jpg";